import { createSelector } from 'reselect';
import moment from 'moment';

import { WMSLayers } from 'components/Leaflet';

const SET_POSITION = 'leaflet/SET_POSITION';
const SET_BASE_LAYER = 'leaflet/SET_BASE_LAYER';
const SET_DATA_LAYER = 'leaflet/DATA_LAYER';
const SET_ZOOM = 'leaflet/SET_ZOOM';
const SET_OPACITY = 'leaflet/SET_OPACITY';
const SET_MAP_DATE = 'leaflet/SET_MAP_DATE';

const initialState = {
  // bounds: [[49, -125], [23, -67]],
  bounds: [
    [40.071237673735865, -75.59282683767378],
    [40.06726382855591, -75.59974157251419],
  ],
  baseLayer: 'googleSat',
  zoomLevel: 17,
  opacity: 30,
  dataLayer: 'none',
  mapDate: moment().format('YYYY-MM-DD'),
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_POSITION: {
      return { ...state, bounds: action.bounds };
    }
    case SET_BASE_LAYER: {
      return { ...state, baseLayer: action.baseLayer };
    }
    case SET_DATA_LAYER: {
      return { ...state, dataLayer: action.dataLayer };
    }
    case SET_ZOOM: {
      return { ...state, zoomLevel: action.zoom };
    }
    case SET_OPACITY: {
      return { ...state, opacity: action.opacity };
    }
    case SET_MAP_DATE: {
      return { ...state, mapDate: action.mapDate };
    }
    default:
      return state;
  }
};

export const setLeafletPosition = (bounds) => {
  return {
    type: SET_POSITION,
    bounds: [
      [bounds._northEast.lat, bounds._northEast.lng],
      [bounds._southWest.lat, bounds._southWest.lng],
    ],
  };
};
export const setBaseLayer = (baseLayer) => ({ type: SET_BASE_LAYER, baseLayer });
export const setDataLayer = (dataLayer) => ({ type: SET_DATA_LAYER, dataLayer });
export const setZoom = (zoom) => ({ type: SET_ZOOM, zoom });
export const setOpacity = (opacity) => ({ type: SET_OPACITY, opacity });
export const setMapDate = (mapDate) => ({ type: SET_MAP_DATE, mapDate: moment(mapDate).format('YYYY-MM-DD') });

const LeafletSelectors = (function () {
  const getLeafletPosition = (state) => state.map.bounds;
  const getBaseLayer = (state) => state.map.baseLayer;
  const getDataLayer = (state) => state.map.dataLayer;
  const getZoom = (state) => state.map.zoomLevel;
  const getOpacity = (state) => state.map.opacity;
  const getMapDate = (state) => state.map.mapDate;
  const getDataLayerConfig = createSelector([getDataLayer, getMapDate], (dataLayer, mapDate) => {
    if (dataLayer === 'none') {
      return undefined;
    }
    const layer = WMSLayers.layers[dataLayer];
    if (layer.layers.includes('DATE')) {
      const url = `${layer.url}&time=${mapDate}`;
      return { ...layer, url };
    }
    return layer;
  });

  return {
    getLeafletPosition,
    getBaseLayer,
    getDataLayer,
    getDataLayerConfig,
    getZoom,
    getOpacity,
    getMapDate,
  };
})();

export default LeafletSelectors;
